import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { ActiveUser } from 'app/utils/helpers.utils';
import { IUser } from 'app/interfaces/user.interface';
import { SchoolContextService } from '../../../app/services/school/school-context.service';

@Component({
  selector: '[core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrls: ['./core-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit {
  currentUser: any;

  @Input()
  layout = 'vertical';

  @Input()
  menu: any;

  // stored user data
  user: IUser = ActiveUser();

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   * @param {SchoolContextService} _schoolContextService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef, 
    private _coreMenuService: CoreMenuService,
    private _schoolContextService: SchoolContextService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();
    
    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();
      this._changeDetectorRef.markForCheck();
    });

    // Subscribe to school type changes
    this._schoolContextService.getCurrentSchoolType().pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe(() => {
      // Refresh menu when school type changes
      this._coreMenuService.refreshDynamicMenu();
    });
  }

  isPermitted(item: any) {
    if (item.role) {
      return this.user?.permissions?.includes(item.role[0].toUpperCase())
    }
    return true
  }
}
